jQuery( document ).ready( function( $ ) {
  // Make mobile category selector go to tag page
  $( '.blog__tags select' ).on( 'change', function() {
    var tagUrl = $( this ).val();

    window.location = tagUrl;
  } )

  function preloadImage(url) {
    if (url) {
      var img = new Image();
      img.src = url;
    }
  }
  $('.article__featuredProductColorCircle').each(function() {
    var imgUrl = $(this).attr('data-variant-image');
    preloadImage(imgUrl);
  });

  $('.article__featuredProductColorCircle').on('click', function() {
    var root = $(this).closest('.article__featuredProduct');
    var imgTarget = root.find('.article__featuredProductImage');
    imgTarget.attr('src', $(this).attr('data-variant-image'));
  });

});